package top.wcpe.allincore.dsl.compiler.codegen

import top.wcpe.allincore.dsl.compiler.ast.ScreenAst
import top.wcpe.allincore.dsl.compiler.pipeline.PlaceholderRegistry
import top.wcpe.allincore.dsl.compiler.pipeline.ThemeRegistry
import top.wcpe.allincore.dsl.ir.model.UiIr

/**
 * codegen 层主入口 facade：AST → IR。
 *
 * 调用方应在 lex/parse/semantic 全部通过后再调用本类。
 */
class IrEmitter(
    private val placeholderRegistry: PlaceholderRegistry? = null,
) {

    private val screen = ScreenEmitter(papi = PapiEmitter(placeholderRegistry))

    /** 兼容旧入口：不传 themeRegistry 时 availableThemes 为空。 */
    fun emit(ast: ScreenAst): UiIr = screen.emit(ast, null)

    fun emit(ast: ScreenAst, themeRegistry: ThemeRegistry?): UiIr = screen.emit(ast, themeRegistry)
}
